import { ControlledModal } from '../../../layouts/components/modal'
import { Teacher, useAppContext } from '../../../providers/context'
import { TeacherConferenceData } from './conferenceComponents'
import { linkTo, pageFocus } from '../../../utils'
import { Button, ButtonStyle } from '../../../components/simple/button'
import React from 'react'
import { TextInput } from '../../../components/form/textInput'
import { Tooltip } from '../../../components/simple/tooltip'
import { makeRequest, showAxiosErrorAsToast } from '../../../request'

export const EditLocationModal: React.FC<{
  user: Teacher
  conference: TeacherConferenceData
  reloadConference: () => void
  open: boolean
  onClose: () => void
}> = ({ user, conference, open, onClose, reloadConference }) => {
  const { reloadUser } = useAppContext()
  const [roomNumber, setRoomNumber] = React.useState(user.conferenceLocation.roomNumber || '')
  const [virtualLink, setVirtualLink] = React.useState(user.conferenceLocation.url || '')
  const [loading, setLoading] = React.useState(false)
  return (
    <ControlledModal
      size="sm"
      disabled={loading}
      open={open}
      onOpenChange={(open) => !open && onClose()}
      title="Your Conference Location"
    >
      {!user.hasGoogleOAuth && (
        <>
          <Button
            className="self-start"
            onClick={async (e) => {
              setLoading(true)
              linkTo('/oauth2G', true)(e)
              await pageFocus()
              reloadConference()
              await reloadUser()
              setLoading(false)
            }}
            buttonStyle={ButtonStyle.blue}
          >
            Connect to Google Calendar
          </Button>
          <div className="-mt-2 text-sm">
            This allows us to add appointments to your calendar automatically, and create meets links for virtual
            conferences.
          </div>
        </>
      )}
      {conference.virtualOrInPerson !== 'virtual' && (
        <>
          <div className="mt-2">Room Number</div>
          <TextInput
            blue
            value={roomNumber}
            onChange={setRoomNumber}
            placeholder="Room number for conference meetings"
          />
        </>
      )}
      {conference.virtualOrInPerson !== 'inperson' && (
        <>
          <div className="mt-2">Virtual meeting link</div>
          <Tooltip text={user.hasGoogleOAuth ? 'Managed through Google Calendar' : undefined}>
            <TextInput
              blue
              value={virtualLink}
              onChange={setVirtualLink}
              disabled={user.hasGoogleOAuth}
              placeholder="Link for virtual meetings"
            />
          </Tooltip>
        </>
      )}
      {conference.virtualOrInPerson === 'inperson' && user.hasGoogleOAuth && (
        <>
          Calendar Appointments
          <TextInput blue value="Managed through Google Calendar" disabled />
        </>
      )}
      <Button
        logo
        className="mt-2 self-start"
        onClick={() => {
          setLoading(true)
          makeRequest('/ptc/editlocation', {
            room_number: roomNumber,
            meets_link: virtualLink,
          })
            .catch(showAxiosErrorAsToast)
            .then(() => {
              reloadUser()
              reloadConference()
              onClose()
            })
            .finally(() => setLoading(false))
        }}
      >
        Save
      </Button>
    </ControlledModal>
  )
}
